import React, { useState } from 'react';
import SideNavUx from "../../layout/sidenav";
import NavBarUx from "../../layout/navbar";
import FooterUx from "../layout/footer_ux";
const PaymentUx = (props) => {
    const [openSidenav, setOpenSidenav] = useState(false);
    const [formData, setFormData] = useState({
        discountCode: "",
        nameOnCard: "",
        cardNumber: "",
        expirationMonth: "01",
        expirationYear: "2024",
        securityCode: "",
    });

    const routes = {main: 'Pagos', current: 'Pagos'}


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", formData);
        alert("Form submitted successfully!");
    };

    return (
        <>
            <SideNavUx setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
            <div className="p-4 xl:ml-80">
                <NavBarUx routes={routes} setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                <div className="min-w-screen min-h-screen py-5">
                    <div className="w-full bg-white  border-gray-200 px-5 py-10 text-gray-800">
                        <div className="w-full">
                            <div className="-mx-3 md:flex">
                                <div className="px-3 md:w-8/12 lg:pr-10">
                                    <div className="w-full mx-auto text-gray-800 font-light mb-6 border-b border-gray-200 pb-6">
                                        <div className="w-full flex items-center">
                                            <div className="overflow-hidden rounded-lg w-16 h-16 bg-gray-50 border border-gray-200">
                                                <img
                                                    src="https://images.unsplash.com/photo-1572635196237-14b3f281503f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1160&q=80"
                                                    alt="Product"
                                                />
                                            </div>
                                            <div className="flex-grow pl-3">
                                                <h6 className="font-semibold uppercase text-gray-600">CONCEPTO DE PAGO</h6>
                                            </div>
                                            <div>
                                                <span className="font-semibold text-gray-600 text-xl">$210</span>
                                                <span className="font-semibold text-gray-600 text-sm">.00</span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Discount Code */}
                                    <div className="mb-6 pb-6 border-b border-gray-200">
                                        <div className="-mx-2 flex items-end justify-end">
                                            <div className="flex-grow px-2 lg:max-w-xs">
                                                <label className="text-gray-600 font-semibold text-sm mb-2 ml-1">
                                                    Discount code
                                                </label>
                                                <div>
                                                    <input
                                                        className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-indigo-500 transition-colors"
                                                        placeholder="XXXXXX"
                                                        type="text"
                                                    />
                                                </div>
                                            </div>
                                            <div className="items-center h-full px-2">
                                                <button
                                                    className="w-full max-w-xs mx-auto border border-transparent bg-gray-500 hover:bg-blue-gray-50 text-white rounded-md px-5 py-2 font-semibold">
                                                    APLICAR
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Totals */}
                                    <div className="mb-6 pb-6 border-b border-gray-200 text-gray-800">
                                        <div className="w-full flex mb-3 items-center">
                                            <div className="flex-grow">
                                                <span className="text-gray-600">Subtotal</span>
                                            </div>
                                            <div className="pl-3">
                                                <span className="font-semibold">$190.91</span>
                                            </div>
                                        </div>
                                        <div className="w-full flex items-center">
                                            <div className="flex-grow">
                                                <span className="text-gray-600">Taxes (GST)</span>
                                            </div>
                                            <div className="pl-3">
                                                <span className="font-semibold">$19.09</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-6 pb-6 border-b border-gray-200 md:border-none text-gray-800 text-xl">
                                        <div className="w-full flex items-center">
                                            <div className="flex-grow">
                                                <span className="text-gray-600">Total</span>
                                            </div>
                                            <div className="pl-3">
                                                <span className="font-semibold text-gray-400 text-sm">AUD</span>{" "}
                                                <span className="font-semibold">$210.00</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Payment Section */}
                                <div className="px-3 md:w-5/12">
                                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 p-3 text-gray-800 font-light mb-6">
                                        <div className="w-full flex mb-3 items-center">
                                            <div className="w-32">
                                                <span className="text-gray-600 font-semibold">Contact</span>
                                            </div>
                                            <div className="flex-grow pl-3">
                                                <span>Scott Windon</span>
                                            </div>
                                        </div>
                                        <div className="w-full flex items-center">
                                            <div className="w-32">
                                                <span className="text-gray-600 font-semibold">Billing Address</span>
                                            </div>
                                            <div className="flex-grow pl-3">
                                                <span>123 George Street, Sydney, NSW 2000 Australia</span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Payment Method */}
                                    <div className="w-full mx-auto rounded-lg bg-white border border-gray-200 text-gray-800 font-light mb-6">
                                        <div className="w-full p-3 border-b border-gray-200">
                                            <div className="py-4 px-4 items-center">
                                                <div className="my-3 items-center">
                                                    <label htmlFor="type1" className="flex items-center cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            className="form-radio h-5 w-5 text-indigo-500"
                                                            name="type"
                                                            id="type1"
                                                            defaultChecked
                                                        />
                                                        <img
                                                            src="https://leadershipmemphis.org/wp-content/uploads/2020/08/780370.png"
                                                            alt="Credit Card"
                                                            className="h-6 ml-3"
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="min-w-screen py-5">
                                                <div className="w-full bg-white border-t border-gray-200 px-5 py-10 text-gray-800">
                                                    <form className="max-w-2xl mx-auto" onSubmit={handleSubmit}>
                                                        <div className="mb-2">
                                                            <label className="text-gray-600 font-semibold text-sm mb-2 ml-1 block">
                                                                Name on Card
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="nameOnCard"
                                                                value={formData.nameOnCard}
                                                                onChange={handleChange}
                                                                className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-indigo-500 transition-colors"
                                                                placeholder="John Smith"
                                                            />
                                                        </div>

                                                        <div className="mb-2">
                                                            <label className="text-gray-600 font-semibold text-sm mb-2 ml-1 block">
                                                                Card Number
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="cardNumber"
                                                                value={formData.cardNumber}
                                                                onChange={handleChange}
                                                                className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-indigo-500 transition-colors"
                                                                placeholder="0000 0000 0000 0000"
                                                            />
                                                        </div>

                                                        <div className="mb-6 flex space-x-4">
                                                            <div className="w-1/3">
                                                                <label
                                                                    className="text-gray-600 font-semibold text-sm mb-2 ml-1 block">
                                                                    Exp. Month
                                                                </label>
                                                                <select
                                                                    name="expirationMonth"
                                                                    value={formData.expirationMonth}
                                                                    onChange={handleChange}
                                                                    className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-indigo-500 transition-colors"
                                                                >
                                                                    {Array.from({length: 12}, (_, i) => (
                                                                        <option key={i + 1}
                                                                                value={String(i + 1).padStart(2, "0")}>
                                                                            {String(i + 1).padStart(2, "0")}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="w-1/3 mx-2">
                                                                <label
                                                                    className="text-gray-600 font-semibold text-sm mb-2 ml-1 block">
                                                                    Exp. Year
                                                                </label>
                                                                <select
                                                                    name="expirationYear"
                                                                    value={formData.expirationYear}
                                                                    onChange={handleChange}
                                                                    className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-indigo-500 transition-colors"
                                                                >
                                                                    {Array.from({length: 10}, (_, i) => (
                                                                        <option key={i} value={2024 + i}>
                                                                            {2024 + i}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="w-1/3">
                                                                <label
                                                                    className="text-gray-600 font-semibold text-sm mb-2 ml-1 block">
                                                                    CVV
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="securityCode"
                                                                    value={formData.securityCode}
                                                                    onChange={handleChange}
                                                                    className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-indigo-500 transition-colors"
                                                                    placeholder="000"
                                                                />
                                                            </div>
                                                        </div>

                                                        <button
                                                            type="submit"
                                                            className="w-full bg-indigo-500 hover:bg-indigo-600 text-white rounded-md px-5 py-3 font-semibold"
                                                        >
                                                            PAGAR
                                                        </button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterUx/>
            </div>
        </>
    );
}

export default PaymentUx;